import { useQuery } from '@tanstack/react-query';
import { fetchSecretSettingStatus } from '../services/dealerSecretSettings';

export const dealerSecretSettingKeys = {
    all: ['dealers', 'secret-config-settings'] as const,
    detail: (dealerId: string, key: string) => [...dealerSecretSettingKeys.all, dealerId, key] as const,
};

export const useDealerSecretSettingQuery = (dealerId: string, key: string) =>
    useQuery({
        queryKey: dealerSecretSettingKeys.detail(dealerId, key),
        queryFn: () => fetchSecretSettingStatus(dealerId, key),
        enabled: Boolean(dealerId),
    });
